import { ContractStatus } from '../../enums/contract-status'
import { DonationType } from '../../enums/donation-type'
import { PaymentMethodType } from '../../enums/payment-method-type'
import { TransactionStatus } from '../../types/donation/transaction-status'
import { translations } from '../translations/translations-manager'

export const paymentMethodTypeStrings: Record<PaymentMethodType, () => string> = {
  'stripe-card': () => translations.texts.payment_method_card_present.toString(),
  'stripe-setup-card': () => translations.texts.payment_method_card_present.toString(),
  'stripe-payment-sheet': () => translations.texts.payment_method_other.toString(),
  'stripe-setup-payment-sheet': () => translations.texts.payment_method_other.toString(),
  'external-sepa-debit': () => translations.texts.payment_method_sepa_debit.toString(),
  cash: () => translations.texts.payment_method_cash.toString(),
}

export const contractStatusStrings: Record<ContractStatus, () => string> = {
  draft: () => translations.texts.contract_status_draft.toString(),
  intent: () => translations.texts.contract_status_intent.toString(),
  finalized: () => translations.texts.contract_status_finalized.toString(),
  externally_managed: () => translations.texts.contract_status_externally_managed.toString(),
  completed: () => translations.texts.contract_status_completed.toString(),
  canceled: () => translations.texts.contract_status_canceled.toString(),
}

export const transactionStatusStrings: Record<TransactionStatus, () => string> = {
  'payment-request': () => translations.texts.transaction_status_payment_request.toString(),
  draft: () => translations.texts.transaction_status_draft.toString(),
  paid: () => translations.texts.transaction_status_paid.toString(),
  refunded: () => translations.texts.transaction_status_refunded.toString(),
  disputed: () => translations.texts.transaction_status_disputed.toString(),
  'pre-transaction': () => translations.texts.transaction_status_pre_transaction.toString(),
  failed: () => translations.texts.transaction_status_failed.toString(),
  pending: () => translations.texts.transaction_status_pending.toString(),
  retrying: () => translations.texts.transaction_status_retrying.toString(),
  canceled: () => translations.texts.transaction_status_canceled.toString(),
  requiresAction: () => translations.texts.transaction_status_requires_action.toString(),
  maxAttemptsReached: () => translations.texts.transaction_status_max_attempts_reached.toString(),
}

export const contractTypeStrings: Record<DonationType, () => string> = {
  'one-off': () => translations.texts.contract_type_one_off.toString(),
  recurring: () => translations.texts.contract_type_recurring.toString(),
}
